<template>
  <div class="blockC matching-box clearfix" style="margin-top: 20px">
    <div class="blockC-detail">
      <div class="blockC-tip"></div>
      <span class="blockC-title">承运人信息：</span>
      <RadioGroup class="radioGroup" style="margin-left: 20px;" v-model="formData.shipperType" @on-change="changeRadio">
        <Radio :label="1" v-show="showComp">平台企业</Radio>
        <Radio :label="2" v-show="showUser" :style="showComp ? 'margin-left: 20px;':''">企业用户</Radio>
        <Radio :label="3" v-show="showUser" style="margin-left: 20px;">个人</Radio>
      </RadioGroup>
    </div>
    <vxe-form
        style="margin-top: 10px;"
        ref="seller"
        class="my-form"
        title-align="right"
        :data="formData"
        :rules="chooseComp ? formRules2 : (formData.shipperType === 2 ? formRules : formRules1)"
        title-width="120"
        prevent-submit>
      <vxe-form-item title="平台企业名称" field="shipper" span="8" v-if="formData.shipperType === 1">
        <template>
          <div :class="compCheck ? 'input-border border-red' : 'input-border'">
            <platform-corp
                class="corp"
                :row="formData"
                :field="'shipper'"
                :isDefault="true"
                :placeholder="'请选择平台企业'"
                @select="selectComp"
            ></platform-corp>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="开户行" field="shipperBank" span="8" v-if="formData.shipperType === 1">
        <template v-slot="scope">
          <vxe-input v-model="formData.shipperBank" placeholder="请输入开户行" clearable
                     @input="$refs.seller.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="账号" field="shipperAccount" span="8" v-if="formData.shipperType === 1">
        <template v-slot="scope">
          <vxe-input v-model="formData.shipperAccount" placeholder="请输入账号" clearable
                     @input="$refs.seller.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="企业名称" field="shipperName" span="16" v-if="formData.shipperType === 2">
        <template>
          <vxe-pulldown class="vxe-pulldown--content" ref="compDown2" transfer>
            <template v-slot>
              <vxe-input v-model="formData.shipperName" placeholder="请输入企业名称"
                         @input="inputEvent"></vxe-input>
            </template>
            <template v-slot:dropdown>
              <div class="chainId-dropdown">
                <vxe-grid
                    border="none"
                    highlight-hover-row
                    auto-resize
                    height="auto"
                    :loading="compLoading"
                    :data="tableData"
                    :columns="columns"
                    @cell-click="cellClick"
                ></vxe-grid>
              </div>
            </template>
          </vxe-pulldown>
        </template>
      </vxe-form-item>
      <vxe-form-item title="个人名称" field="shipperName" span="16" v-if="formData.shipperType === 3">
        <template v-slot="scope">
          <vxe-input v-model="formData.shipperName" placeholder="请输入签约方姓名" clearable
                     @input="$refs.seller.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="手机号" field="shipperPhone" span="8"
                     v-if="formData.shipperType === 2 || formData.shipperType === 3">
        <template v-slot="scope">
          <vxe-input v-model="formData.shipperPhone" :placeholder="chooseComp ? '选填' : '必填'" clearable
                     @input="$refs.seller.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="开户行" field="shipperBank" span="16"
                     v-if="formData.shipperType === 2 || formData.shipperType === 3">
        <template v-slot="scope">
          <vxe-input v-model="formData.shipperBank" placeholder="请输入开户行" clearable
                     @input="$refs.seller.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="账号" field="shipperAccount" span="8"
                     v-if="formData.shipperType === 2 || formData.shipperType === 3">
        <template v-slot="scope">
          <vxe-input v-model="formData.shipperAccount" placeholder="请输入账号" clearable
                     @input="$refs.seller.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>
  import PlatformCorp from "@/components/common/PlatformCorp";
  import $api from "@/apiProvider";

  export default {
    props: ['palletType', 'isSubmit', 'isCancel', 'isSave', 'detailData'],
    components: {PlatformCorp},
    data() {
      const number = ({itemValue}) => {
        if (itemValue && itemValue !== "") {
          let reg = /^\d+(?=\.{0,1}\d+$|$)/;
          if (!reg.test(itemValue)) {
            return Promise.reject(new Error("请输入正确的数字"));
          }
        }
      };
      return {
        showComp: true,
        showUser: true,
        formData: {
          shipper: null,
          shipperId: null,
          shipperType: null,
          shipperName: null,
          shipperPhone: null,
          shipperBank: null,
          shipperAccount: null,
        },
        formRules2: {
          shipperName: [{required: true, message: "请输入企业名称"}],
          shipperAccount: [{validator: number}],
        },
        formRules1: {
          shipper: [{required: true, message: "请选择平台企业"}],
          shipperName: [{required: true, message: "请输入个人姓名"}],
          shipperPhone: [{required: true, message: "请输入手机号"}, {min: 11, max: 11, message: "请输入正确的手机号"}],
          shipperAccount: [{validator: number}],
        },
        formRules: {
          shipper: [{required: true, message: "请选择平台企业"}],
          shipperName: [{required: true, message: "请输入企业名称"}],
          shipperPhone: [{required: true, message: "请输入手机号"}, {min: 11, max: 11, message: "请输入正确的手机号"}],
          shipperAccount: [{validator: number}],
        },
        tableData: [],
        columns: [{field: "compName", title: "企业名称"}, {field: "regisiterNum", title: "手机号"}], // 选择平台企业下拉框数据列
        compLoading: false,
        chooseComp: false,
        compCheck: false
      }
    },
    watch: {
      palletType(val) {
        if (val === 1) {
          this.formData.shipper = null;
          this.formData.shipperId = null;
          this.formData.shipperName = null;
          this.formData.shipperPhone = null;
          this.formData.shipperBank = null;
          this.formData.shipperAccount = null;
          this.formData.shipperType = 2;
          this.showComp = false;
          this.showUser = true;
        } else {
          this.showComp = true;
          if (this.formData.shipperType === 1) {
            if (val === 2 || val === 3) {
              return
            }
            this.showUser = true;
          } else {
            this.formData.shipperType = 1;
            this.formData.shipper = null;
            this.formData.shipperId = null;
            this.formData.shipperName = null;
            this.formData.shipperPhone = null;
            this.formData.shipperBank = null;
            this.formData.shipperAccount = null;
            this.showUser = false;
          }
        }
      },
      isSubmit(val) {
        if (val) {
          this.check();
        }
      },
      isCancel(val) {
        if (val) {
          this.reset();
        }
      },
      isSave(val) {
        if (val) {
          this.setParams();
        }
      },
      detailData(val) {
        if (val) {
          if (this.detailData.palletType === 1) {
            if (this.detailData.secondPartyIsPlat === 1) {
              this.chooseComp = true;
            }
            this.showComp = false;
            this.showUser = true;
          } else {
            this.showComp = true;
            if (this.detailData.shipperType === 1) {
              this.showUser = true;
            } else {
              this.detailData.shipperType = 1;
              this.showUser = false;
            }
          }
          this.formData = {
            shipperId: this.detailData.shipperId,
            shipperType: this.detailData.shipperType,
            shipper: this.detailData.shipperName,
            shipperName: this.detailData.shipperName,
            shipperPhone: this.detailData.shipperPhone,
            shipperBank: this.detailData.shipperBank,
            shipperAccount: this.detailData.shipperAccount
          }
        }
      }
    },
    methods: {
      async check() {
        const errMap = await this.$refs.seller.validate().catch(errMap => errMap);
        if (errMap) {
          if (!this.formData.shipper || this.formData.shipper === '') {
            this.compCheck = true;
          } else {
            this.compCheck = false;
          }
          this.$emit("setParams", false);
          return
        }
        this.compCheck = false;
        this.setParams();
      },
      setParams() {
        // 过滤参数
        let obj = {
          shipperId: this.formData.shipperId,
          shipperType: this.formData.shipperType,
          shipperName: this.formData.shipperName,
          shipperPhone: this.formData.shipperPhone,
          shipperBank: this.formData.shipperBank,
          shipperAccount: this.formData.shipperAccount
        };
        this.$emit("setParams", obj);
      },
      changeRadio(val) {
        this.$emit("setShipperType", val);
        this.formData.shipper = null;
        this.formData.shipperName = null;
        this.formData.shipperBank = null;
        this.formData.shipperAccount = null;
        this.formData.shipperPhone = null;
        this.chooseComp = false;
        this.clearValidate();
      },
      selectComp(bool, index, row) {
        this.formData.shipperName = index.shipper;
        this.formData.shipperBank = row.bankName;
        this.formData.shipperAccount = row.accountNum;
        this.clearValidate();
      },
      focusEvent() {
        if (this.formData.shipperName) {
          this.$refs.compDown2.showPanel();
          this.queryUserList(this.formData.shipperName)
        }
      },
      inputEvent(val) {
        this.chooseComp = false;
        if (val && val !== '') {
          this.chooseComp = false;
          this.$refs.compDown2.showPanel();
          this.queryUserList(val)
        }
      },
      cellClick({row}) {
        this.clearValidate();
        if (row.aboutCompId) {
          this.chooseComp = true;
        } else {
          this.chooseComp = false;
        }
        this.formData.shipperName = row.compName;
        this.formData.shipperPhone = row.regisiterNum;
        this.formData.shipperBank = row.bankName;
        this.formData.shipperAccount = row.accountNum;
        this.$refs.compDown2.hidePanel();
      },
      async queryUserList(val) {
        this.compLoading = true;
        let res = await $api.baseUserSign.post("queryUserList", {
          page: 1,
          rows: 1000,
          username: val,
          userType: 2
        });
        this.compLoading = false;
        if (res.status === 1) {
          this.tableData = res.data.rows;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      clearValidate() {
        this.$refs.seller.clearValidate();
        this.compCheck = false;
      },
      reset() {
        this.formData = {
          shipperType: null,
          shipperName: null,
          shipperPhone: null,
          shipperBank: null,
          shipperAccount: null,
        };
        this.chooseComp = false;
        this.clearValidate();
      }
    }
  };
</script>

<style scoped>
  .input-border {
    display: flex;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    padding-left: 10px;
    border: 1px solid #f2f1f1;
  }

  .input-border >>> .link-text {
    color: #438DF3;
  }

  .border-red {
    border-color: #f56c6c;
  }

  .my-dropdown1 {
    height: 200px;
    overflow: auto;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
  }

  .list-item1:hover {
    background-color: #f5f7fa;
  }

  .vxe-pulldown--content {
    width: 100%;
  }

  .corp >>> .link-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 180px !important;
  }

</style>